// The chat's task card opens a list by dispatching a window event (the
// transcript renders outside any router); this bridge, mounted inside the
// app's router, turns it into a navigation to the list with the task
// selected (#11942, round 3).
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { listPath } from "./TaskRow";

export const OPEN_TASK_LIST_EVENT = "openTaskList";

export interface OpenTaskListDetail {
  listId: string;
  taskId?: string | null;
}

export const openTaskList = (detail: OpenTaskListDetail): void => {
  window.dispatchEvent(new CustomEvent(OPEN_TASK_LIST_EVENT, { detail }));
};

/** Asked first of a run page (round 33, Gerry: "it shouldn't redirect you
 * to Tasks > Lists, should keep you in the agent ecosystem"): the page that
 * shows the task's run opens it in its own pane and cancels the event. */
export const OPEN_RUN_TASK_EVENT = "openRunTask";

/** Open a task where the reader is: on the run page when one is up and
 * holds the task, else on its list's page. */
export const openTask = (detail: OpenTaskListDetail): void => {
  if (detail.taskId) {
    const asked = new CustomEvent(OPEN_RUN_TASK_EVENT, {
      detail,
      cancelable: true,
    });
    if (!window.dispatchEvent(asked)) return;
  }
  openTaskList(detail);
};

const TaskListEventBridge: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const onOpen = (e: Event) => {
      const detail = (e as CustomEvent<OpenTaskListDetail>).detail;
      if (!detail?.listId) return;
      const query = detail.taskId
        ? `?task=${encodeURIComponent(detail.taskId)}`
        : "";
      navigate(`${listPath(detail.listId)}${query}`);
    };
    window.addEventListener(OPEN_TASK_LIST_EVENT, onOpen);
    return () => window.removeEventListener(OPEN_TASK_LIST_EVENT, onOpen);
  }, [navigate]);
  return null;
};

export default TaskListEventBridge;
